import { render, staticRenderFns } from "./cText.vue?vue&type=template&id=4c89491a&scoped=true"
import script from "./cText.vue?vue&type=script&lang=js"
export * from "./cText.vue?vue&type=script&lang=js"
import style0 from "./cText.vue?vue&type=style&index=0&id=4c89491a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c89491a",
  null
  
)

export default component.exports